import algoliasearch from 'algoliasearch/lite'
import SearchProvider from './searchProvider'
import { getConfig } from './config'

export default ({ $config, nuxtState }) => {
    const client = algoliasearch(
        $config.runtime.integrations.algolia.appId,
        $config.runtime.integrations.algolia.apiKey
    )

    // Loop through the serialized search states and create their client side instances.
    const searchContexts = Object.keys(nuxtState.$search).reduce((acc, key) => {
        acc[key] = new SearchProvider(client, nuxtState.$search[key])
        return acc
    }, {})

    const config = getConfig($config.platform.mode)
    searchContexts.addDynamicContentContext = (id) => {
        if (searchContexts[id]) return
        searchContexts[id] = new SearchProvider(client, {
            indexName: config.indexes.content,
        })
    }

    return searchContexts
}
